import api from './axios';

export const getApartments = async (params) => {
  const response = await api.get('/apartments', { params });
  return response.data;
};

export const getApartmentsByTower = async (tower) => {
  const response = await api.get(`/apartments/tower/${tower}`);
  return response.data;
};

export const getApartment = async (id) => {
  const response = await api.get(`/apartments/${id}`);
  return response.data;
};

export const updateApartment = async (id, data) => {
  const response = await api.put(`/apartments/${id}`, data);
  return response.data;
};

export const importApartments = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post('/apartments/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const uploadTenantDoc = async (id, type, file) => {
  const formData = new FormData();
  formData.append('type', type);
  formData.append('file', file);
  const response = await api.post(`/apartments/${id}/tenant-doc`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const addVehicle = async (apartmentId, data) => {
  const response = await api.post(`/apartments/${apartmentId}/vehicles`, data);
  return response.data;
};

export const removeVehicle = async (apartmentId, vehicleId) => {
  const response = await api.delete(`/apartments/${apartmentId}/vehicles/${vehicleId}`);
  return response.data;
};

export const getGasReadings = async (params) => {
  const response = await api.get('/gas-readings', { params });
  return response.data;
};

export const getLatestReading = async (apartmentId) => {
  const response = await api.get(`/gas-readings/latest/${apartmentId}`);
  return response.data;
};

export const storeReading = async (data) => {
  const response = await api.post('/gas-readings', data);
  return response.data;
};

export const updateReading = async (id, data) => {
  const response = await api.put(`/gas-readings/${id}`, data);
  return response.data;
};

export const exportReadings = async (params) => {
  const response = await api.get('/gas-readings/export', {
    params,
    responseType: 'blob',
  });
  return response;
};

export const exportReadingsNbh = async (params) => {
  const response = await api.get('/gas-readings/export-nbh', {
    params,
    responseType: 'blob',
  });
  return response;
};

export const checkLateReadings = async (params) => {
  const response = await api.get('/gas-readings/late-readings', { params });
  return response.data;
};

export const getNbhExportHistory = async () => {
  const response = await api.get('/gas-readings/nbh-export-history');
  return response.data;
};

export const getNbhExportHistoryDetail = async (id) => {
  const response = await api.get(`/gas-readings/nbh-export-history/${id}`);
  return response.data;
};

export const recallNbhReadings = async (id, apartmentIds = []) => {
  const response = await api.post(`/gas-readings/nbh-export-history/${id}/recall`, {
    apartment_ids: apartmentIds,
  });
  return response.data;
};

export const getGasSettings = async () => {
  const response = await api.get('/gas-settings');
  return response.data;
};

export const updateGasSettings = async (data) => {
  const response = await api.put('/gas-settings', data);
  return response.data;
};

export const clearAllGasReadings = async () => {
  const response = await api.delete('/gas-readings/clear-all');
  return response.data;
};
